export default __webpack_public_path__ + "static/media/github-logo.ce47d339.svg";